"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ExchangerUtils = void 0;
var CustomCurrencyCodeEnums_1 = require("../../app/types/enum/CustomCurrencyCodeEnums");
var CurrencyEnum_1 = require("../enums/CurrencyEnum");
var ExchangerUtils = /** @class */ (function () {
    function ExchangerUtils() {
    }
    ExchangerUtils.conver = function (exchanger, currencyCode) {
        var cc = require('currency-codes');
        switch (currencyCode) {
            case parseInt(cc.code(CurrencyEnum_1.CurrencyEnum.EUR).number):
                return exchanger.wme;
            case parseInt(cc.code(CurrencyEnum_1.CurrencyEnum.RUB).number):
                return 1;
            case parseInt(cc.code(CurrencyEnum_1.CurrencyEnum.UAH).number):
                return exchanger.wmu;
            case parseInt(cc.code(CurrencyEnum_1.CurrencyEnum.USD).number):
                return exchanger.wmz;
            case CustomCurrencyCodeEnums_1.CustomCurrencyCodeEnums.BINANCE_USDT_CODE:
                return exchanger.wmz;
            default:
                return 1;
        }
    };
    return ExchangerUtils;
}());
exports.ExchangerUtils = ExchangerUtils;
